import { array, element, node, number, oneOfType, string } from "prop-types";

import classes from "./totals.scss";

const CheckoutProductTotals = ({ className, main, additional }) => {
  return main || additional ? (
    <div className={className || classes.root}>
      {main && (
        <div className={classes.main} data-t1="totals_main" data-t2={main}>
          {main}
        </div>
      )}
      {additional && <div className={classes.additional}>{additional}</div>}
    </div>
  ) : null;
};

CheckoutProductTotals.propTypes = {
  className: string,
  main: oneOfType([number, string, element, array, node]),
  additional: oneOfType([number, string, element, array, node]),
};

CheckoutProductTotals.defaultProps = {
  className: "",
  main: "",
  additional: "",
};

export default CheckoutProductTotals;
